export enum PatientInformationConstants {
  NOT_IMPLEMENTED = 'PatientInformation/NOT_IMPLEMENTED',
  SET_SELECTED_OPTION = 'PatientInformation/SET_SELECTED_OPTION',
  PATIENT_DEMOGRAPHICS_OPTION = 'PatientInformation/PatientDemographics',
  PATIENT_MEDICAL_HISTORY_OPTION = 'PatientInformation/PatientMedicalHistory',
  PATIENT_MEDICAL_HISTORY_SEARCH_LIST_OPTION = 'PatientInformation/MedicalHistoryLookupContent',
  PATIENT_ALLERGIES_OPTION = 'PatientInformation/PatientAllergies',
  PATIENT_ALLERGIES_SEARCH_LIST_OPTION = 'PATIENT_ALLERGIES_SEARCH_LIST_OPTION',
  PATIENT_MEDICATION_OPTION = 'PatientInformation/PatientMedication',
  PATIENT_SEARCH_OPTION = 'PatientInformation/PatientSearch',
  PATIENT_SEARCH_RESULTS_OPTION = 'PatientInformation/PatientSearchResults',
  SET_HIDE_PATIENT_AND_BILLING = 'PatientInformation/SET_HIDE_PATIENT_AND_BILLING',
  SET_SEARCH_IMPORT = 'PatientInformation/SET_SEARCH_IMPORT',
  SET_NEW_PATIENT = 'PatientInformation/SET_NEW_PATIENT',
  REPLACE_PATIENT = 'PatientInformation/REPLACE_PATIENT',
  REFRESH_PATIENT_DATA = 'PatientInformation/REFRESH_PATIENT_DATA',
  SET_PATIENT_INFORMATION = 'PatientInformation/SET_PATIENT_INFORMATION',
  SET_DO_NOT_RESUSCITATE = 'PatientInformation/SET_DO_NOT_RESUSCITATE',
  SET_BARRIERS_TO_CARE = 'patientInformation/SET_BARRIERS_TO_CARE',
  SET_PREFERRED_LANGUAGE = 'patientInformation/SET_PREFERRED_LANGUAGE',
  ENABLE_PAGE_SCROLL = 'PatientInformation/ENABLE_PAGE_SCROLL',
  RESET_PATIENT_INFORMATION_STATE = 'PatientInformation/RESET_PATIENT_INFORMATION_STATE',
  SET_PATIENT_INFORMATION_STATE = 'PatientInformation/SET_PATIENT_INFORMATION_STATE',
  SET_HAS_PATIENT = 'PatientInformation/SET_HAS_PATIENT',
}
